module.exports = __webpack_public_path__ + "static/img/kawachi_07.6343a82.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/kawachi_07.jpg
// module id = B7bz
// module chunks = 0